import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faStarHalfAlt } from '@fortawesome/free-solid-svg-icons';
import '../styles/StarRating.css';

function StarRating({ rating, editable = false, onChange, size = '1em' }) {
  const [hoverRating, setHoverRating] = useState(0);
  const [isUpdating, setIsUpdating] = useState(false);

  const handleClick = async (clickedValue) => {
    if (!editable || isUpdating) return;
    
    // If clicking the same rating value, remove rating (set to null)
    const newRating = rating === clickedValue ? null : clickedValue;
    
    setIsUpdating(true);
    try {
      await onChange(newRating);
      // Add brief animation
      const starElement = document.querySelector(`.star-rating [data-star="${Math.ceil(clickedValue)}"]`);
      if (starElement) {
        starElement.classList.add('star-saved');
        setTimeout(() => starElement.classList.remove('star-saved'), 300);
      }
    } catch (error) {
      console.error('Failed to update rating:', error);
    } finally {
      setIsUpdating(false);
    }
  };

  const handleMouseMove = (e, starNumber) => {
    if (!editable || isUpdating) return;
    
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const width = rect.width;
    const isFirstHalf = x < width / 2;
    
    const value = isFirstHalf ? starNumber - 0.5 : starNumber;
    setHoverRating(value);
  };

  const handleMouseLeave = () => {
    setHoverRating(0);
  };

  const renderStar = (starNumber) => {
    const currentRating = rating || 0;
    const displayRating = hoverRating || currentRating;
    
    // Determine the fill state of this star
    let fillType = 'empty';
    if (displayRating >= starNumber) {
      fillType = 'full';
    } else if (displayRating >= starNumber - 0.5) {
      fillType = 'half';
    }
    
    return (
      <span
        key={starNumber}
        data-star={starNumber}
        className={`star-wrapper ${editable ? 'editable' : ''} ${isUpdating ? 'updating' : ''}`}
        onClick={(e) => {
          if (!editable) return;
          const rect = e.currentTarget.getBoundingClientRect();
          const x = e.clientX - rect.left;
          const width = rect.width;
          const isFirstHalf = x < width / 2;
          const value = isFirstHalf ? starNumber - 0.5 : starNumber;
          handleClick(value);
        }}
        onMouseMove={(e) => handleMouseMove(e, starNumber)}
        onMouseLeave={handleMouseLeave}
        style={{ fontSize: size }}
      >
        {fillType === 'half' ? (
          <span className="star-container">
            <FontAwesomeIcon 
              icon={faStar} 
              className="star-bg"
              style={{ color: '#ddd' }}
            />
            <FontAwesomeIcon 
              icon={faStarHalfAlt} 
              className="star-half-overlay"
              style={{ color: '#FFD700' }}
            />
          </span>
        ) : (
          <FontAwesomeIcon 
            icon={faStar} 
            className={fillType === 'full' ? 'star-filled' : 'star-empty'}
            style={{ color: fillType === 'full' ? '#FFD700' : '#ddd' }}
          />
        )}
      </span>
    );
  };

  return (
    <div className="star-rating">
      {[1, 2, 3, 4, 5].map(renderStar)}
      {editable && rating && (
        <span className="rating-text">({rating}/5)</span>
      )}
    </div>
  );
}

export default StarRating;